var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "noticeInfo",
    staticStyle: {
      "margin-left": "20%"
    },
    attrs: {
      model: _vm.noticeInfo,
      "label-width": "90px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "选择渠道",
      required: ""
    }
  }, [_c("channel-options", {
    attrs: {
      multiple: _vm.addOrEdit == 1
    },
    model: {
      value: _vm.noticeInfo.channel_id,
      callback: function callback($$v) {
        _vm.$set(_vm.noticeInfo, "channel_id", $$v);
      },
      expression: "noticeInfo.channel_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "公告类型",
      required: ""
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.noticeInfo.type,
      callback: function callback($$v) {
        _vm.$set(_vm.noticeInfo, "type", $$v);
      },
      expression: "noticeInfo.type"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "公告名称",
      required: ""
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "400px"
    },
    model: {
      value: _vm.noticeInfo.title,
      callback: function callback($$v) {
        _vm.$set(_vm.noticeInfo, "title", $$v);
      },
      expression: "noticeInfo.title"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "公告内容",
      required: ""
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "400px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: _vm.noticeInfo.content,
      callback: function callback($$v) {
        _vm.$set(_vm.noticeInfo, "content", $$v);
      },
      expression: "noticeInfo.content"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "公告期限",
      required: ""
    }
  }, [[_c("time-date-options", {
    attrs: {
      clearable: false,
      disabled: false
    },
    model: {
      value: _vm.timedata,
      callback: function callback($$v) {
        _vm.timedata = $$v;
      },
      expression: "timedata"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "是否弹出"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.noticeInfo.is_pop,
      callback: function callback($$v) {
        _vm.$set(_vm.noticeInfo, "is_pop", $$v);
      },
      expression: "noticeInfo.is_pop"
    }
  }), _vm._v(" " + _vm._s(_vm.pop[_vm.noticeInfo.is_pop]) + " ")], 1), _c("el-form-item", {
    attrs: {
      label: "公告状态"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.noticeInfo.status,
      callback: function callback($$v) {
        _vm.$set(_vm.noticeInfo, "status", $$v);
      },
      expression: "noticeInfo.status"
    }
  }), _vm._v(" " + _vm._s(_vm.status[_vm.noticeInfo.status]) + " ")], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.onSubmit();
      }
    }
  }, [_vm._v(_vm._s(_vm.addOrEdit == 1 ? "立即创建" : "立即修改"))]), _c("el-button", {
    on: {
      click: _vm.onCancel
    }
  }, [_vm._v("取消")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };